import { Runtime } from "fp";

import React from "react";

import * as ErrorMessage from "~/ErrorMessage";
import { Order } from "~/Order";
import { Search } from "~/Search";
import { Version } from "~/Version";

import { Platform } from "./Platform";

export type Application = { readonly application: Partial<Version> };

export function Application({ application: { version } }: Application) {
  return version ? (
    <>
      E Logs <Version version={version} />
    </>
  ) : (
    <ErrorMessage.Component icon danger>
      Missing E Logs
    </ErrorMessage.Component>
  );
}

export namespace Application {
  export const { equals, compare } = Order.fromCompare<Application>((a, b) =>
    Order.optionally(Version.compare)(
      a.application.version && { version: a.application.version },
      b.application.version && { version: b.application.version }
    )
  );

  export const isOutdated = (latest: Version) => ({
    application,
  }: Application): boolean =>
    application.version !== undefined &&
    Version.isOutdated(latest)({ version: application.version });

  export const toSearch: Search.From<Application> = ({
    application: { version },
  }) => Search.string(version ? Version.toString({ version }) : "");

  export namespace Response {
    export const runtime = () => Version.Response.runtime();
    export const decode = (
      response: Runtime.ToType<typeof runtime>
    ): Application | undefined => {
      const version = Version.Response.decode(response);
      return version ? { application: { ...version } } : undefined;
    };
  }

  export namespace Latest {
    export const iOS = (): Version => ({ version: [3, 2, 14, 110] });
    export const android = (): Version => ({ version: [3, 2, 14, 101] });
    export const fromPlatform = (platform: Platform): Version =>
      Platform.when(platform, { iOS, android });
  }
}
